import React from 'react';
import { useFetchEntity } from '../../Services/fetchApi';
import Tabs from 'react-bootstrap/Tabs'
import { Button, Container, Row, Label, Col } from 'reactstrap'
import Tab from 'react-bootstrap/Tab'
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import DataTable from '../Form/DataTable';
import { useEffect } from 'react';
import { endpoints } from '../../utils/Constants';
import { useAuth } from '../../Services/AuthContext';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import LoadingAnimation from '../Form/LoadingAnimation';
import { showDate, showDateTime, showTime } from '../../utils/Helpers';
import useCheckMobileScreen from '../../utils/Hooks/useCheckMobileScreen';
import CharterShare from '../Editors/CharterShare';
import JobReference from '../Editors/JobReference';

const TopLabel = ({ children }) => <Row><Label style={{ fontSize: '10px' }} >{children}</Label></Row>

const SecondLabel = ({ children }) => <Row><Label style={{ fontSize: '15px', fontFamily: 'RobotoBold' }} >{children}</Label></Row>
const MobileColumn = ({ charterShare, route }) => {
    const { share, request } = charterShare;
    const rout = charterShare.route;
    // const [route] = routes;
    const history = useHistory();
    const onCharterSelect = (requestId) => {
        history.push(route + '/' + requestId);
    }

    return share ? <Container className='p-0'>
        <Row style={{ backgroundColor: '#006CAA', color: 'white' }}>
            <Container>
                <Container>
                    
                    <Row>
                        <Col>
                            <TopLabel>From:</TopLabel>
                            <SecondLabel>{rout.from}</SecondLabel>

                        </Col>

                        <img alt='' style={{ position: 'relative', width: '50px', top: '10px', height: '50px', right: 0 }} src={"/img/pdf/white-jet.png"} />

                        <Col>
                            <TopLabel>To:</TopLabel>
                            <SecondLabel>{rout.to}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Depart Time:</TopLabel>
                            <SecondLabel>{showDateTime(rout.departTime)}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Status:</TopLabel>
                            <SecondLabel>{share.status}</SecondLabel>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Row>
        <Row>
            <Container>
                <Container>
                    <Row>
                        <Col>
                            <TopLabel>Job Ref:</TopLabel>
                            <SecondLabel>JB{request.jobReference}</SecondLabel>
                        </Col>
                      
                        <Col>
                            <TopLabel>Cost:</TopLabel>
                            <SecondLabel>${share.costPerSeat}</SecondLabel>
                        </Col>
                        <Col>
                            <Container>
                             

                                <Button color="primary" className='float-right' style={{ position: 'absolute', right: 0, bottom: 0, }}
                                    onClick={() => onCharterSelect(share.id)}>View</Button>
                            </Container>

                        </Col>
                    </Row>
                </Container>
            </Container>
        </Row>
    </Container> : null
}


const CharterSharesTabList = ({ route, headerHeight, tabItem, all, parentHeight }) => {


    const mobileColumns = [
        {
            accessor: (x) => {
                return x.request.jobReference
            },
            Cell: ({ row }) => {
                return <MobileColumn charterShare={row.original} route={route} />
            },
            Header: 'Job Reference',

        }
    ]

    const actions = [{ name: 'View', action: (row) => onCharterSelect(tabItem.purchase ? row.purchase.id:row.share.id) },];
    const { activeKey } = useParams();
    const isMobile = useCheckMobileScreen();
    const [requests, loading, error] = useFetchEntity({
        name: tabItem.entity.name,
        getByStatus: () => ((all ? (tabItem.purchase ? tabItem.endpointAllPurchases : tabItem.endpointAll) : (tabItem.purchase ? tabItem.endpointPurchases : tabItem.endpoint)) + '/' + encodeURIComponent(tabItem.route))
    });
    const history = useHistory();

    const onCharterSelect = (requestId) => {
        history.push(route + '/' + requestId);
    }

    return <React.Fragment>

        <Container><Row><Col><h1> {tabItem.entity.plural}</h1></Col><Col></Col></Row></Container>
     {error ? <p>Error</p>
            : !error && loading ? <LoadingAnimation />
                : requests&& requests.length?<DataTable
                    parentHeight={parentHeight}
                    title={<h1>Charter Requests</h1>}
                    data={requests ? requests : []}
                    heightOffset={headerHeight}
                    columns={!isMobile ? tabItem.columns : mobileColumns}
                    actions={!isMobile ? actions : []} />:<h1>No Shares in this category</h1>}

    </React.Fragment>;
}

const CharterShareSupplier = ({ all, route, tabItem, item, parentHeight }) => {
    let history = useHistory();
    const params = useParams();
    const { activeKey } = params;

    const { tabs } = tabItem;
    useEffect(() => {
        if (tabs && history) {
            const requestedTab = tabs.find(x => x.route === activeKey);
            const activeTabKey = requestedTab ? requestedTab.route : tabs[0].route;
            if (activeKey !== activeTabKey) {
                //        history.push(theRoute + '/' + activeTabKey+'/Me);
            }
        }
    }, [tabs, activeKey, history, route]);
    const setActiveTab = (tab) => {
        if (activeKey !== tab) {
            history.push(route + '/' + tab);
        }
    }

    const headerHeight = 60;

    return <React.Fragment>
        <Tabs mountOnEnter activeKey={activeKey} onSelect={setActiveTab} >
            {tabs.map((tab, i) => <Tab key={i} eventKey={tab.route} title={tab.name} tabClassName={tab.className} >
                {(i && tabItem && activeKey === tab.route)||!i ? <CharterSharesTabList item={item} parentHeight={parentHeight} all={all} tabItem={{ ...tabItem, ...tab }} route={route + '/' + tab.route} headerHeight={headerHeight} /> : null}
            </Tab>)}
        </Tabs>
    </React.Fragment>
}


const CharterShares= ({ area, route, item, parentHeight }) => {
    const params = useParams();
    const history = useHistory();

    const { list, activeKey, clientStaffId, clientId, clientDepartmentId, supplierId, charterRequestId } = params
    const liveColumns = [
        {
            accessor: (x) => x.request.jobReference,
            Cell: ({ row }) => <JobReference charter={row.original.request} />,
            Header: 'Job Reference',

        },
        {
            accessor: (x) => x.route.departTime,
            Cell: ({ row }) => { return showDate(row.original.route.departTime) + '\n' + showTime(row.original.route.departTime) },
            Header: 'Depart Time',

        },
        {
            accessor: (x) => x.route.from,
            Header: 'From',

        },
        {
            accessor: (x) => x.route.to,
            Header: 'To',

        },
        {
            accessor: (x) => x.share.seatsAvailable,
            Header: 'Seats',

        },
        {
            accessor: (x) => x.share.costPerSeat,
            Header: 'Cost',

        },

    ]
    const myColumns = [{ accessor: 'share.status', Header: 'Status' },
        {
            accessor: (x) => x.request.jobReference,
            Cell: ({ row }) => <JobReference charter={row.original.request} />,
            Header: 'Job Reference',

        },{
            accessor: (x) => x.route.departTime,
            Cell: ({ row }) => { return showDate(row.original.route.departTime) + '\n' + showTime(row.original.route.departTime) },
            Header: 'Depart Time',

        },
        {
            accessor: (x) => x.route.from,
            Header: 'From',

        },
        {
            accessor: (x) => x.route.to,
            Header: 'To',

        },
        {
            accessor: (x) => x.share.seatsAvailable,
            Header: 'Seats',

        },
        {
            accessor: (x) => x.share.costPerSeat,
            Header: 'Cost',

        },


    ];
   

    const clientTabs = [
        {
            route: 'Live',
            name: "Live",
            filterItems: ["Live"],
            className: 'tabBlack',
            columns: liveColumns,
            entity: entities.charterShare,
        },
        {
            route: 'Confirmed', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Shares</div>
                </Row>
            </Container>, filterItems: ["Confirmed"], className: 'tabGreen',
            columns: myColumns,
            entity: entities.charterSharePurchase,
            purchase: true,
        },
        {
            route: 'Pending', name: 'Pending', filterItems: ["Pending"], className: 'tabBlack',
            columns: myColumns,
            entity: entities.charterShare,
        },
       
        {
            route: 'PendingPurchase',
            name: <Container>
                < Row >
                    <div style={{ alignContent: 'center', width: '100%' }}>Pending</div>
                </Row >
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Purchase</div>
                </Row>
            </Container >,
            filterItems: ["Pending"],
            className: 'tabOrange',
            columns: myColumns,
            entity: entities.charterSharePurchase,
            purchase: true,
        },
        {
            route: 'All', name: 'All', filterItems: ["All"], className: 'tabBlack',
            columns: myColumns,
            entity: entities.charterShare,
        },];
    const tabs = [
        {
            route: 'Live',
            name: "Live",
            filterItems: ["Live"],
            className: 'tabBlack',
            columns: liveColumns,
            entity: entities.charterShare,
        },
        {
            route: 'Confirmed',
            name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Shares</div>
                </Row>
            </Container>,
            filterItems: ["Confirmed"],
            className: 'tabGreen',
            columns: myColumns,
            entity: entities.charterSharePurchase,
            purchase: true,
        },
        {
            route: 'Pending', name: 'Pending', filterItems: ["Pending"], className: 'tabBlack',
            columns: myColumns,
            entity: entities.charterShare,
        },
        {
            route: 'All', name: 'All', filterItems: ["All"], className: 'tabBlack',
            columns: myColumns,
            entity: entities.charterShare,
        },

    ];
    const supplierTabs = [
        {
            route: 'Live',
            name: "Live",
            filterItems: ["Live"],
            className: 'tabBlack',
            columns: liveColumns,
            entity: entities.charterShare,
        },
        {
            route: 'Mine', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>My Charter</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Shares</div>
                </Row>
            </Container>, filterItems: ["Mine"], className: 'tabGreen',
            columns: liveColumns,
            entity: entities.charterShare,
        },
    ];

    const [auth] = useAuth();
    const items = {
        "Admin/supplier": {
            id: supplierId,
            endpoint: endpoints.getSupplierCharterShareByStatus,
            endpointPurchases: endpoints.getSupplierCharterSharePurchasesByStatus,
            tabs: supplierTabs
        },
        "Admin/client": {
            id: clientId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientAllCharterSharePurchasesByStatus,
            tabs: tabs
        },
        "Admin/department": {
            id: clientDepartmentId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientDepartmentAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientDepartmentOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientDepartmentAllCharterSharePurchasesByStatus,
            tabs: tabs
        },
        "Admin/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            tabs: tabs
        },
        "Admin/": {
            endpoint: endpoints.adminCharterShares,
            endpointPurchases: endpoints.adminCharterSharePurchases,
            tabs: tabs
        },
        "Supplier/": {
            id: auth?.supplierId ? auth.supplierId : supplierId,
            endpoint: endpoints.getSupplierCharterShareByStatus,
            endpointPurchases: endpoints.getSupplierCharterShareByStatus,
            tabs: supplierTabs
        },
        "Client/client": {
            id: auth.clientId ? auth.clientId : clientId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientAllCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "Client/": {
            id: auth.clientId ? auth.clientId : clientId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientAllCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "Client/department": {
            id: clientDepartmentId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientDepartmentAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientDepartmentOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientDepartmentAllCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "Client/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "ClientDepartment/": {
            id: auth.clientDepartmentId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientDepartmentAllCharterShareByStatus,
            tabs: clientTabs,
            endpointPurchases: endpoints.getClientDepartmentOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientDepartmentAllCharterSharePurchasesByStatus,
        },
        "ClientDepartment/department": {
            id: auth.clientDepartmentId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointAll: endpoints.getClientDepartmentAllCharterShareByStatus,
            endpointPurchases: endpoints.getClientDepartmentOnlyCharterSharePurchasesByStatus,
            endpointAllPurchases: endpoints.getClientDepartmentAllCharterSharePurchasesByStatus,
            tabs: clientTabs,
            },
        "ClientDepartment/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "ClientStaff/": {
            id: auth.clientStaffId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
        "ClientStaff/staff": {
            id: auth.clientStaffId,
            endpoint: endpoints.getClientOnlyCharterShareByStatus,
            endpointPurchases: endpoints.getClientOnlyCharterSharePurchasesByStatus,
            tabs: clientTabs
        },
    }

    const definition = items[auth.role + '/' + area];

    const setActiveTab = (tab) => {
        if (list !== tab) {
            history.push(route + '/' + tab);
        }
    }
    const tab = definition.tabs.find(x => x.route === activeKey);


    if (!definition.endpointAll) {
        return definition ? <React.Fragment>
            <CharterShareSupplier parentHeight={parentHeight} item={item ? item : { id: definition.id }} tabItem={definition} route={route + "/Me"} headerHeight={0} />
            <Switch>

                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list/:activeKey'}
                    render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' >
                        <CharterShare route={route + '/' + list + '/' + activeKey} />
                    </ClientModal>} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' ><CharterShare route={route + '/' + list + '/' + activeKey} /></ClientModal>} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' ><CharterShare route={route + '/' + list + '/' + activeKey} /></ClientModal>} />

            </Switch>
        </React.Fragment> : null;
    } else {
        return <React.Fragment>
            <Tabs mountOnEnter activeKey={list} onSelect={setActiveTab} >
                <Tab key={"All"} eventKey={"All"} title={"All"} >
                    {definition && list !== 'Me' ? <CharterShareSupplier parentHeight={parentHeight} all item={item ? item : { id: charterRequestId }} tabItem={definition} route={route + '/' + list} headerHeight={60} /> : null}
                </Tab>
                <Tab key={"Me"} eventKey={"Me"} title={"Me"} >
                    {definition && list === 'Me' ? <CharterShareSupplier parentHeight={parentHeight} item={item ? item : { id: charterRequestId }} tabItem={definition} route={route + '/' + list} headerHeight={60} /> : null}
                </Tab>
            </Tabs>
            <Switch>
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list/:activeKey'} render={() =>
                    <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' >
                        <CharterShare route={route + '/' + list + '/' + activeKey} />
                    </ClientModal>} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' ><CharterShare route={route + '/' + list + '/' + activeKey} /></ClientModal>} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={tab?.entity} itemParam='charterRequestId' ><CharterShare route={route + '/' + list + '/' + activeKey} /></ClientModal>} />
            </Switch>
        </React.Fragment>
    }

};
export default CharterShares; 